import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import {
  IInventoryRepository,
  IMeepResponseErrors,
  IOrderDetailValidation,
  IOrderValidationRequest,
} from "Infrastructure/repositories/api/InventoryRepository";
import { IOrder } from "modules/order/domain/models/IOrder";

export interface IValidateInventoryResult {
  success: boolean;
  message?: string;
}

const buildOrderValidationRequest = (
  order: IOrder,
  kiosk: Kiosk
): IOrderValidationRequest => {
  const detailsByKey = new Map<string, IOrderDetailValidation>();

  order.orderItems.forEach((item) => {
    const key = `${item.productId}#${item.realPrice}`;
    const existing = detailsByKey.get(key);

    if (existing) {
      existing.Quantity += item.quantity;
      existing.TotalValue = existing.Value * existing.Quantity;
    } else {
      detailsByKey.set(key, {
        ProductId: item.productId,
        Quantity: item.quantity,
        Value: item.realPrice,
        TotalValue: item.realPrice * item.quantity,
      });
    }
  });

  return {
    Id: order.id,
    OwnerId: kiosk.localId,
    OrderDate: order.createdAt,
    DeviceId: kiosk.id,
    Details: Array.from(detailsByKey.values()),
  };
};

export const ValidateInventoryUseCase = async (
  inventoryRepository: IInventoryRepository,
  order: IOrder,
  kiosk: Kiosk
): Promise<IValidateInventoryResult> => {
  const request = buildOrderValidationRequest(order, kiosk);

  try {
    await inventoryRepository.validateOrderAsync(request);
    return { success: true };
  } catch (error) {
    const responseErrors: IMeepResponseErrors | undefined = (error as any)
      ?.response?.data;
    return {
      success: false,
      message:
        responseErrors?.message ??
        "Erro ao verificar disponibilidade de estoque",
    };
  }
};
